import React, { useEffect, useState } from "react";

import styles from "../../styles/order-details.module.scss";

import {
  ClockIcon,
  MapMarkerIcon,
  PhoneIcon,
  WhatsApp,
} from "../components/Icons";
import { Icon } from "../components/core/Icon";
import dayjs from "dayjs";
import { BrazilStates } from "../utils/BrazilStates";
import { Method } from "../utils/Payment";
import { Phone } from "../utils/Phone";

const locale_ptbr = require("dayjs/locale/pt-br");
const relativeTime = require("dayjs/plugin/relativeTime");
dayjs.locale(locale_ptbr);
dayjs.extend(relativeTime);

const DeliveryType = {
  DELIVER_ON_ADDRESS: 1,
  GET_ON_PLACE: 2,
  INDOOR: 3,
};

const OrderOrigin = {
  ONLINE: "ONLINE",
  OFFLINE: "OFFLINE",
};

export default class Customer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  paymentMethod(payment) {
    const payers = payment?.payers || [];
    const firstPayer = payers[0];
    if ((payers || []).length === 0) {
      return "Desconhecido";
    }
    const { MethodType, method } = firstPayer;
    if (MethodType?.toUpperCase().includes("ITP")) {
      return MethodType.replace("-", " - ");
    }
    return Method[method]?.name || "Desconhecido";
  }

  generateAddressString(deliveryAddress) {
    if (!deliveryAddress || !deliveryAddress.address) {
      return "Erro no endereço";
    }

    let stringAddress = `${deliveryAddress.address}`;

    if (deliveryAddress.number) {
      stringAddress += `, ${deliveryAddress.number}`;
    }

    if (deliveryAddress.complement) {
      stringAddress += ` (${deliveryAddress.complement})`;
    }

    if (deliveryAddress.observation) {
      stringAddress += ` ${deliveryAddress.observation}`;
    }

    const shortNameState = BrazilStates.getShortNameByName(
      deliveryAddress.state
    );

    stringAddress += ` - ${deliveryAddress.region} - ${deliveryAddress.city}/${shortNameState}`;
    return stringAddress;
  }

  formatDate(date) {
    return dayjs(date).format("DD/MM/YYYY");
  }

  formatTime(date) {
    return `${dayjs(date).format("HH:mm")} - ${dayjs(date)
      .add(1, "hour")
      .format("HH:mm")}`;
  }

  render() {
    const { order } = this.props;
    const {
      customer_infos: customer,
      delivery,
      created_at,
      payment,
      origin,
    } = order;

    const OrderOrigin = {
      ONLINE: "ONLINE",
      TOTEM: "TOTEM",
    };

    const getOrderOrigin = (origin) => {
      const origins = {
        [OrderOrigin.ONLINE]: "App",
        [OrderOrigin.TOTEM]: "Totem",
      };

      return origins[origin];
    };

    return (
      <div className={styles.customer}>
        <div className={styles.header}>
          <p className={styles.customerName}>{customer.name}</p>
          {order.position && (
            <span className={styles.password}>Senha #{order.position}</span>
          )}
        </div>

        <div className={styles.phone}>
          <WhatsApp />
          {customer.phone && (
            <a
              href={`https://wa.me/55${customer?.phone.replace(/\D/g, "")}`}
              target={"_blank"}
              rel="noreferrer"
            >
              <p>
                <span>{Phone.mask(customer.phone)}</span>
                <i className="far fa-external-link" />
              </p>
            </a>
          )}
        </div>
        {origin != OrderOrigin.OFFLINE && (
          <div className={styles.item}>
            <div className={styles.icon}>
              <Icon name="bell" size="1x" />
            </div>
            <p>{getOrderOrigin(order.origin)}</p>
          </div>
        )}
        <div className={styles.item}>
          <div className={styles.icon}>
            <ClockIcon />
          </div>
          <p>{dayjs(created_at).format("DD/MM/YYYY HH:mm:ss")}</p>
        </div>
        <div className={styles.item}>
          <div className={styles.icon}>
            <MapMarkerIcon />
          </div>
          <p>
            {delivery.type == DeliveryType.GET_ON_PLACE && "Retirada no balcão"}
            {delivery.type == DeliveryType.INDOOR && "Retirada no balcão"}
            {delivery.type == DeliveryType.DELIVER_ON_ADDRESS &&
              this.generateAddressString(delivery.address)}
          </p>
        </div>
        <div className={styles.item}>
          <div className={styles.icon}>
            <Icon name="credit-card-blank" size="1x" />
          </div>
          <p>{this.paymentMethod(payment)}</p>
        </div>
        <div className={styles.item}>
          <div className={styles.icon}>
            <Icon name="check" size="1x" />
          </div>
          <p>
            {payment &&
              payment.payers.length > 0 &&
              `CPF na nota: ${
                payment.payers[0]["user"]["extras"] &&
                payment.payers[0]["user"]["extras"]["doc"]
                  ? `${
                      payment.payers[0]["user"]["extras"]["doc"].replace(
                        /(\d{3})(\d{3})(\d{3})(\d{2})/,
                        "$1.$2.$3-$4"
                      ) || "Desconhecido"
                    }`
                  : "Não"
              }`}
          </p>
        </div>
        {order.delivery.scheduledFor && (
          <div className={styles.scheduling}>
            <div className={styles.icon}>
              <Icon name="calendar" light size="1x" />
            </div>
            <div className="d-flex flex-column">
              <p>Agendamento</p>
              <div className="d-flex align-center">
                <span className={styles.day}>
                  {this.formatDate(order.delivery.scheduledFor)}
                </span>
                <div className={styles.divisor} />
                <span className={styles.time}>
                  {this.formatTime(order.delivery.scheduledFor)}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
